import styled from '@emotion/styled';

export const Title = styled.div`
  text-align: center;
  font-size: 24px;
  line-height: 32px;
  font-family: NokiaPureHeadline-Regular;
  color: ${({ theme }) => theme.colors.primaryBlue};
  width: 271px;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
